import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Session } from './session';
import * as _ from 'lodash';
import { LocalstorageService } from '../localstorage/localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  public session$: any = null;
  private readonly sessionSubject: BehaviorSubject<
    Session.SESSION
  > = new BehaviorSubject<any>({});
  private readonly userProfileSubject: BehaviorSubject<
    Session.USERPROFILE
  > = new BehaviorSubject<any>({});
  private readonly currentUserSubject: BehaviorSubject<any>;
  public currentUser$: Observable<any>;
  private readonly dealersSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});

  constructor(
    private readonly http: HttpClient,
    private readonly localStorageService: LocalstorageService
  ) {

    const storedUser = sessionStorage.getItem('currentUser');
    let initialUser = null;    
    if (storedUser && storedUser !== '[object Object]') {
      try { initialUser = JSON.parse(storedUser); } catch (e) { console.error(e); }
    }
    this.currentUserSubject = new BehaviorSubject<any>(initialUser);
    this.currentUser$ = this.currentUserSubject.asObservable();    
  }

  get session(): any {
    return this.session$;
  }

  get user(): any {
    return {
      username: this.session.username,
      pacode: this.session.pacode,
      role: this.session.role,
      token: this.session.token,
      dealers: this.session.dealers
    };
  }


  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }
  

  getAllUsers(environment): Observable<any> {
    const url = `${environment.apiAllUsers}`;

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('jwtToken')??''
      })
    };
    return this.http.get(url, httpOptions).pipe(
      //map(this.extractData),
      catchError(this.handleError)
    );
  }

  public login(
    username: string,
    environmentUrl: any
  ): Observable<any> {
    const bodyParams = {
      dcoclientid: username

    }

    return this.http
      .post(environmentUrl.apiUserUrl, bodyParams)
      .pipe(catchError(error => this.errorHandler(error)))
      .pipe(
        map(user => {
          if (user) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            user = _.map(user, o => _.extend({ username: username }, o));
            console.log('setting the current user in the session storage!')
            sessionStorage.setItem('currentUser', JSON.stringify(user));
            this.localStorageService.createUserAndStoreInLocal(user);
            this.currentUserSubject.next(user);
          }
          return user;
        })
      );
  }

  public formatTimeStamp(date: Date): any {
    let hours: any = new Date().getHours();
    let minute: any = new Date().getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours || 12;
    minute = minute < 10 ? '0' + minute : minute;
    const strTime = `${hours}:${minute} ${ampm}`;
    return (
      date.getMonth() +
      1 +
      '/' +
      date.getDate() +
      '/' +
      date.getFullYear() +
      ' ' +
      strTime
    );


  }

  public getSession(): Observable<Session.SESSION> {
    return this.sessionSubject.asObservable();
  }


  public getDealers(): Observable<any> {
    return this.dealersSubject.asObservable();
  }

  public setDealers(dealers: Array<any>): void {
    this.dealersSubject.next(dealers);
  }

  // Get and Set User Profile
  public getUserProfile(): Observable<any> {
    return this.userProfileSubject.asObservable();
  }

  public setUserProfile(userProfile: any): void {
    this.userProfileSubject.next(userProfile);
  }

  private errorHandler(errorResponse: any): Observable<{}> {
    console.log('Error', errorResponse);
    return throwError(errorResponse);
  }


  public handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }
}
